export const Types = {
    LOAD_ALL_DATA_PROVIDERS: "LOAD_ALL_DATA_PROVIDERS",
    LOAD_ALL_DATA_PROVIDERS_FOR_LIST_PAGE: "LOAD_ALL_DATA_PROVIDERS_FOR_LIST_PAGE",
    TOGGLE_DP_SORT: "TOGGLE_DP_SORT",
    DP_GLOBAL_SEARCH: "DP_GLOBAL_SEARCH",

    SET_DP_LIST_FILTER: "SET_DP_LIST_FILTER",
    FILTER_DATA_PROVIDERS: "FILTERED_DATA_PROVIDERS",
}

export const Detail = {
    LOAD_PROVIDER_DETAIL: "LOAD_PROVIDER_DETAIL_AND_ASSOCIATED_SERVICES",
    CLEAR_DP_DETAIL_PAGE: "CLEAR_DP_DETAIL_PAGE",
    DELETE_DP_WARNING: "DELETE_WARNING_FOR_DP",
}


export const DPSortFields = {
    PROVIDER_NAME: "provider_name",
    STATUS: "integration_status",
}

